<template>
  <div class="cmhub-header sys-sign-out">
    <a-dropdown>
      <div class="user-name">
        <span class="user-avatar">
          <img :src="userIcon" class="user-avatar-img" alt="" />
        </span>
        <span class="user-text">{{ username }}</span>
        <svg class="user-caret" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M4.5 6.25 8 9.75l3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <a-menu slot="overlay">
        <a-menu-item>
          <div @click="logout">退出</div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>
<script>
import { rmToken } from '@/utils/authStorage';
import { getUnifiedAuth } from '../session';

export default {
  data() {
    return {
      userIcon: require('@/assets/images/pageTabUser.png'),
    };
  },
  computed: {
    username() {
      const auth = getUnifiedAuth();
      return auth ? ((auth.customer.available ? auth.customer : auth.merchant).name || '客商融合') : '';
    },
  },
  methods: {
    logout() {
      rmToken();
      this.$store.commit('emptyTab');
      this.$router.replace('/login');
    },
  },
};
</script>
<style lang="less" scoped>
.sys-sign-out {
  .user-name {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    cursor: pointer;
    font-size: 14px;
    color: #222222;

    .user-avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      flex-shrink: 0;

      .user-avatar-img {
        width: 28px;
        height: 28px;
        object-fit: contain;
      }
    }

    .user-caret {
      width: 14px;
      height: 14px;
      flex-shrink: 0;
      color: #222222;
    }
  }
}
</style>
